import dayjs from 'dayjs'
import tzAbbr from '@/lib/time-zone.js'

function getTime (isLosAngeles) {
  let offset = isLosAngeles 
    ? new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }) 
    : undefined

  let day = dayjs(offset)
  let time = day.format('h:mm a')
    .replace('am', 'a.m.')
    .replace('pm', 'p.m.')
  let timezone = isLosAngeles ? 'PST' : tzAbbr()

  return { 
    time, 
    timezone, 
    date: day.format('MMMM D'), 
    dow: day.format('dddd') 
  }
}

let timers = {
  timeout: null,
  interval: null
}

export default {
  state: {
    local: getTime(),
    la: getTime(true)
  },
  mutations: {
    updateTime (state) {
      state.local = getTime()
      state.la = getTime(true)
    }
  },
  actions: {
    startTime ({ commit, dispatch }) {
      // kick off clock timer at top of the minute
      
      // get current number of seconds to calc
      // how far we are from top of minute const
      const offset = new Date().getSeconds()
      timers.timeout = setTimeout(() => {
        commit('updateTime')
        dispatch("updateNowPlaying");

        // now that we are at top of minute,
        // update time every minute
        timers.interval = setInterval(() => {
          commit('updateTime')
          dispatch("updateNowPlaying");
        }, 1000 * 60)
      }, (60 - offset) * 1000)
    },
    stopTime () {
      clearTimeout(timers.timeout)
      clearInterval(timers.interval)
    }
  },
}